import Log from "../view/log";
import CustomerFlowOverView from "../view/CustomerFlow/OverView/OverView";
import MonitorPointManagement from "../view/CustomerFlow/MonitorPointManagement/MonitorPointManagement";
import MonitorPointManagementAdd from "../view/CustomerFlow/MonitorPointManagement/MonitorPointManagementAdd";
import MonitorPointManagementModify from "../view/CustomerFlow/MonitorPointManagement/MonitorPointManagementModify";
import CustomerFlowStatistics from "../view/CustomerFlow/CustomerFlowStatistics/CustomerFlowStatistics";
import CustomerFlowNav from "../view/CustomerFlow/CustomerFlowNav";

export default [
  {
    path: "/customer_flow_over_view",
    name: "customer-flow-over-view",
    components: {
      default: CustomerFlowNav,
      a: CustomerFlowOverView
    }
  },
  {
    path: "/monitor_point_management",
    name: "monitor-point-management",
    components: {
      default: CustomerFlowNav,
      a: MonitorPointManagement
    }
  },
  {
    path: "/monitor_point_management_add",
    name: "monitor-point-management-add",
    components: {
      default: CustomerFlowNav,
      a: MonitorPointManagementAdd
    }
  },
  {
    path: "/monitor_point_management_modify/:id",
    name: "monitor-point-management-modify",
    components: {
      default: CustomerFlowNav,
      a: MonitorPointManagementModify
    }
  },
  {
    path: "/customer_flow_statistics",
    name: "customer-flow-statistics",
    components: {
      default: CustomerFlowNav,
      a: CustomerFlowStatistics
    }
  },
  {
    path: "/customer_log",
    name: "customer-log",
    components: {
      default: CustomerFlowNav,
      a: Log
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/CustomerFlow.js